import { render, staticRenderFns } from "./terms_and_conditions.vue?vue&type=template&id=7111e97f&"
import script from "./terms_and_conditions.vue?vue&type=script&lang=js&"
export * from "./terms_and_conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports